import trophy from "../../assets/trophy.png";
import PrizeCard from "./PrizeCard";
import prizeBanner from '../../assets/prizeBanner.png'
const Prize = () => {
  const prizeData = [
    {
      type: "2nd Prize",
      amount: "To Be Released",
      img: trophy,
    },
    {
      type: "1st Prize",
      amount: "To Be Released",
      img: trophy,
    },
    {
      type: "3rd Prize",
      amount: "To Be Released",
      img: trophy,
    },
  ];
  return (
    <div id="prizes" className="bg-[rgba(26,21,5,0.6)] relative py-10 md:px-20 sm:px-8 px-4   w-[100%] min-h-[40vh]">
      <h1 className="text-center mb-8 font-[Varela] text-[#ee2a7b] font-bold text-5xl">
        Prizes
      </h1>
      <div className="w-full flex items-center justify-center">
        <img className="rounded-lg w-[80%]" src={prizeBanner} alt="" />
      </div>
    </div>
  );
};
export default Prize;
